export default class askAboutProductModal {

  constructor() {
    this.askAboutProductBtn        = document.getElementById("askAboutProductJs");
    this.popupModalWrapper = document.querySelector("#askAboutProductModalJs");
    this.popupModalLayer = document.querySelector("#askAboutProductModalJs .itemPopup__layer");
    this.popupModal = document.querySelector("#askAboutProductModalJs .itemPopup");
    this.popupModalClose   = document.querySelector("#askAboutProductModalJs .itemPopupHeader__close");
    this.popupModalAlertSection  = document.querySelector(".alert");
    this.popupModalAlertSuccess  = document.querySelector(".alert__item--success");
    this.popupModalAlertError  = document.querySelector(".alert__item--error");

    this.askAboutProductBtnSend   = document.getElementById("submitAskAboutProductJs");
    this.askAboutProductsEmail  = document.getElementById("ask-about-p-email");
    this.askAboutProductsPhone  = document.getElementById("ask-about-p-phone");
    this.askAboutProductsMessage  = document.getElementById("ask-about-p-message");

    if (this.popupModal) {
      this.events();
    }
  }

  events() { 

    this.popupModalLayer.addEventListener("click", this.closeModal.bind(this));
    this.popupModalClose.addEventListener("click", this.closeModal.bind(this));

    let self = this;
    this.askAboutProductBtn.addEventListener(
        "click", function() {
          self.openModal();
        }
    );

    this.askAboutProductBtnSend.addEventListener(
      "click", function() {
        let email = self.askAboutProductsEmail.value;
        let phone = self.askAboutProductsPhone.value;
        let message = self.askAboutProductsMessage.value;

        let validateEmail = self.validateEmail(email);
        let validatePhone = self.validatePhone(phone);
        let validateMessage = self.validateMessage(message);

        if(validateEmail && validatePhone && validateMessage) {
          let data = {
            'action': 'askAboutProduct',
            'productId': self.askAboutProductBtn.dataset.productId,
            'email': email,
            'phone': phone,
            'message': message,
            'nonce': self.askAboutProductBtn.dataset.nonce,
          }

          self.sendForm(data);
        } else {
          
        }
      }
    );

    this.askAboutProductsEmail.addEventListener(
      "change", function() {
        self.validateEmail(this.value);
      }
    );

    this.askAboutProductsPhone.addEventListener(
      "change", function() {
        self.validatePhone(this.value);
      }
    );

    this.askAboutProductsMessage.addEventListener(
      "change", function() {
        self.validateMessage(this.value);
      }
    );
  }

  askAboutProduct() {
    this.askAboutProductModal.style.display = "block";
  }

  askAboutProductClose() {
    this.askAboutProductModal.style.display = "none";
  }

  closeModal() {
    let self = this;
    let id = this.popupModal.dataset.id;
    this.popupModalWrapper.classList.remove("active");
  }

  openModal() {
    this.popupModalWrapper.classList.add("active");
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(re.test(email)) {
      this.askAboutProductsEmail.classList.remove("form__input--error");
    } else {
      this.askAboutProductsEmail.classList.add("form__input--error");
    }

    return re.test(email);
  }

  validateMessage(message) {

    if(message.length > 0) {
      this.askAboutProductsMessage.classList.remove("form__input--error");
      return true;
    } else {
      this.askAboutProductsMessage.classList.add("form__input--error");
      return false;
    }
  }

  validatePhone(phone) {
    const re = /^[0-9]{0,9}$/;

    if(re.test(phone)) {
      this.askAboutProductsPhone.classList.remove("form__input--error");
    } else {
      this.askAboutProductsPhone.classList.add("form__input--error");
    }

    return re.test(phone);
  }

  sendForm(data) {
    let btnSend = this.askAboutProductBtnSend;
    let self = this;
    
    if(this.checkCookieLimit()) {
      jQuery.ajax({
        url: ajax.ajaxurl,
        type: 'POST',
        data: data,
        beforeSend:function() {
          btnSend.style.opacity = "0.6";
          btnSend.disabled = true;
          self.hideAlerts();
        },
        success: function (response) {
          btnSend.style.opacity = "1";
          btnSend.disabled = false;
          response = JSON.parse(response);
          self.openAlert(response);
        },
        error: function (request) {
          console.log(request.responseText);
        }
      }) 
    } else {
      self.hideAlerts();
      self.resetForm();
      self.openAlert(false);
    }
  }

  checkCookieLimit() {
    let cookie = parseInt(this.getCookie('woocommerce_ask_about_product'));
    if(!cookie) {
      this.setCookie('woocommerce_ask_about_product', 1);
      return true;
    }

    if(cookie < 5) {
      let cookieValue = cookie+1;
      this.setCookie('woocommerce_ask_about_product', cookieValue);
      return true;
    } else {
      return false;
    }
  }

  openAlert(response) {
    if(response) {
      this.popupModalAlertSection.style.display = "block";
      this.popupModalAlertSuccess.style.display = "block";
      this.resetForm();
    } else {
      this.popupModalAlertSection.style.display = "block";
      this.popupModalAlertError.style.display = "block";
    }
  }

  hideAlerts() {
    this.popupModalAlertSection.style.display = "none";
    this.popupModalAlertSuccess.style.display = "none";
    this.popupModalAlertError.style.display = "none";
  }

  resetForm() {
    this.askAboutProductsEmail.value = "";
    this.askAboutProductsPhone.value = "";
    this.askAboutProductsMessage.value = "";
  }

  setCookie(cname, cvalue) {
    let d = new Date();
    d.setTime(d.getTime() + (5*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";expires=" + expires;
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}